import React from 'react';
import { H2, P, OL, LI, FeatureLink, Callout } from './_shared';

export default {
  slug: 'sending-for-signature',
  title: 'Sending documents for e-signature',
  category: 'folders',
  summary: 'Multi-doc envelopes via DocuSign (default) or Inkless. Add signers, place tags, send, track.',
  searchTerms: ['e-sign', 'signature', 'docusign', 'inkless', 'envelope', 'send'],
  related: ['folder-lifecycle', 'compliance'],
  Body: () => (
    <>
      <P>
        E-signature in RealtyFlows runs through DocuSign by default, with
        Inkless as an alternate provider. Both are wired behind a single
        envelope abstraction so the agent UI is identical regardless of
        which one is sending.
      </P>

      <H2>Sending an envelope</H2>
      <OL>
        <LI>Open a folder, select one or more documents, click "Prepare for Signing."</LI>
        <LI>Add signers — at minimum the buyer/seller, plus any co-signers or witnesses.</LI>
        <LI>Drag signature, initial, and date tags onto each page. Saved field layouts persist across the template, so you only place them once per form.</LI>
        <LI>Review the envelope summary and hit Send.</LI>
      </OL>

      <H2>While it's out for signature</H2>
      <P>
        The folder shows real-time envelope status — Sent, Viewed, Signed by
        [name], Completed. Each event lands in the folder activity feed and
        also pushes to the client's main timeline.
      </P>
      <P>
        Reminders go out automatically at 24h, 72h, and 7d if a signer
        hasn't acted. You can also send a manual nudge from the envelope
        detail page.
      </P>

      <Callout kind="tip">
        For sequential signing (e.g. listing agent first, then seller),
        order signers in the order they should receive the envelope and
        toggle "Sequential routing" before sending.
      </Callout>

      <H2>Picking a provider</H2>
      <P>
        Most agents stay on the DocuSign default. Switch in{' '}
        <FeatureLink to="/settings/integrations">Integrations → E-Signature</FeatureLink>{' '}
        if your brokerage has an Inkless contract — pricing is per envelope
        and Inkless tends to be cheaper at high volume.
      </P>
    </>
  ),
};
